<ng-container *ngIf="state$ | async as state">
    <div class="join-cost-center-cost-unit-container mat-elevation-z8">
        <div class="join-cost-center-cost-unit-table-header">

            <mat-generic-input [fields]="state.selectFields" [(inputFormGroup)]="selectFormGroup"></mat-generic-input>
            <div class="action-buttons">
                <button mat-mini-fab
                        color="primary"
                        matTooltip="{{ 'app.page.join-cost-center-cost-unit.actions.transfer.label' | translate }}"
                        (click)="onClickTransfer()">
                    <mat-icon>sync_alt</mat-icon>
                </button>
                <button mat-mini-fab
                        color="primary"
                        [disabled]="state.selectedCostCenter === null"
                        matTooltip="{{ 'app.page.join-cost-center-cost-unit.actions.add.label' | translate }}"
                        (click)="addKostentraegerToKostenstelle()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>

        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="costUnitName">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-form-field>
                            <input matInput (keyup)="searchCostUnit($event.target.value)" [placeholder]="'app.page.join-cost-center-cost-unit.cost-units.label' | translate">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.costUnit.name }}
                    </td>
                </ng-container>


                <ng-container matColumnDef="costUnitArticleNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.cost-unit.articleNr.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.costUnit.articleNr }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="placeholder">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element"></td>
                </ng-container>

                <ng-container matColumnDef="validFrom">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.join-cost-center-cost-unit.validFrom.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.validFrom | date: 'dd.MM.yyyy' }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="validTo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.join-cost-center-cost-unit.validTo.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.validTo | date: 'dd.MM.yyyy' }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="calculationOrder">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.join-cost-center-cost-unit.calculationOrder.label" | translate }}</th>
                    <td mat-cell matCellEditor *matCellDef="let element">
                        <mat-cell-editor>
                            <mat-form-field class="input-template calculation-order-input">
                                <input matInput
                                       [ngModel]="element.calculationOrder"
                                       (ngModelChange)="checkOrderChange(element, $event)"
                                       (focusout)="onChangeCalculationOrder(element)">
                            </mat-form-field>
                            <span class="output-template">
                                {{ element.calculationOrder == null ? '-' : element.calculationOrder }}
                            </span>
                        </mat-cell-editor>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="actions-column">
                        <button mat-icon-button
                                matTooltip="{{ 'app.page.join-cost-center-cost-unit.actions.edit.label' | translate }}"
                                (click)="onEditDistributionValidity(element)">
                            <mat-icon>edit</mat-icon>
                        </button>

                        <button mat-icon-button
                                color="warn"
                                matTooltip="{{ 'app.page.join-cost-center-cost-unit.actions.delete.label' | translate }}"
                                (click)="onDeleteDistribution(element)">
                            <mat-icon>delete</mat-icon>
                        </button>

                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="state.assignmentColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: state.assignmentColumns"></tr>
            </table>
        </div>
        <mat-paginator [pageSize]="20" [pageSizeOptions]="[20, 50]"></mat-paginator>
    </div>
</ng-container>
